import {combineReducers} from 'redux';
import { omit } from 'lodash';

import user from './user';
import cars from './cars';
import online from './online';

export const getCars = (state) => ({...state.cars})

export const getCarDetails = (state, label) => {
	let result = {};
	const car = getCars(state)[label] || cars(undefined,{type:'NEW_VEHICLE'})[label];
	if(car){
		result = {
			...car.details,
			label:label||"",
		};
	}
	return result;
}

export const getFilter = (state, label) => { 
	return state.cars[label].history.filter;	
}

export const getUser = state => ({...state.user});

export const withoutUser = state => omit(state,'user')

export const getOnlineStatus = state => state.online;

export default combineReducers({user,cars,online});


// WEBPACK FOOTER //
// ./src/reducers/index.js